import { BulkActionConfirmationIconConstants } from 'src/app/shared/constants/bulk-action-confirmation-icon.constants';
import { BulkActionNamesConstants } from 'src/app/shared/constants/bulk-action-names.constants';
import { COLUMNTYPES } from 'src/app/shared/constants/column.constants';
import { Constants } from 'src/app/shared/constants/constants.constant';
import { Column } from 'src/app/shared/models/shared/column';

export class AccountAdminConstants {
	static readonly UserGroupMembersTable = 'commonUserGroupMembersTable';
	static getUserGroupMembersColumns(): Column[] {
		return [
			new Column({ header: 'Employee', field: 'BusinessEntityName' }),
			new Column({ header: 'Status', field: 'BusinessEntityStatusName' }),
			new Column({ header: 'Phone #', field: 'ContactPhone' }),
			new Column({ header: 'Mobile #', field: 'ContactMobile' }),
			new Column({ header: 'E-mail', field: 'ContactEmail' }),
			new Column({ header: 'Include Directly Assigned Only?', field: 'IncludeDirectlyAssignedOnly' }),
		];
	}
	//User Profile Detail
	static readonly Tab_detail_EditUserProfile: string = 'Edit User Profile';

	//External User Profile Detail
	static readonly Tab_detail_EditExternalUserProfile: string = 'Edit External User Profile';

	//User Role Detail
	static readonly Tab_detail_EditUserRole: string = 'Edit User Role';
	static readonly Tab_detail_DeleteUserRole: string = 'Delete User Role';

	//User Role Permission
	static readonly Tab_detail_AddRolePermission: string = 'Add Permission';
	static readonly Tab_detail_DeleteRolePermission: string = 'Delete Permission';

	//User Group Detail
	static readonly Tab_detail_EditUserGroup: string = 'Edit User Group';

	static readonly Tab_detail_AddGroupMember: string = 'Add Group Member';
	static readonly Tab_detail_EditGroupMember: string = 'Edit Group Member';
	static readonly Tab_detail_DeleteGroupMember: string = 'Delete Group Member';

	//BulkAction FilterActions
	static readonly FilterActionsList = [BulkActionNamesConstants.ActionName_Delete];

	static readonly FilterActionsList_Users = [
		BulkActionNamesConstants.ActionName_Activate,
		BulkActionNamesConstants.ActionName_Disable,
		BulkActionNamesConstants.ActionName_SendInvitation,
	];

	//BulkAction ActionIcons
	static readonly ActionIconsNames = [
		{ action: BulkActionNamesConstants.ActionName_Activate, icon: BulkActionConfirmationIconConstants.Confirmation_Title_Icon_Activate },
		{ action: BulkActionNamesConstants.ActionName_Disable, icon: BulkActionConfirmationIconConstants.Confirmation_Title_Icon_Disable },
		{ action: BulkActionNamesConstants.ActionName_Delete, icon: BulkActionConfirmationIconConstants.Confirmation_Title_Icon_Delete },
		{ action: BulkActionNamesConstants.ActionName_SendInvitation, icon: BulkActionConfirmationIconConstants.Confirmation_Title_Icon_SendChanges },
	];

	static readonly BulkAction_Current_Object_Name_ExternalUser = 'ExternalUser';
	static readonly BulkAction_Object_Name_UserRole = 'User Role';
	static readonly BulkAction_Object_PropertyName_UserRole = 'UserRoleName';

	static readonly BulkAction_Object_Name_User = 'User';
	static readonly BulkAction_Object_PropertyName_User = 'Username';

	static readonly BulkAction_Object_Name_ExternalUser = 'External User';

	//subscriber
	static readonly Tab_detail_EditSubscriber: string = 'Edit Subscriber';

	//Column Types
	static readonly ListType_ExternalUser: string = 'ExternalUser';
	static readonly ListType_User: string = 'User';
	static readonly ListType_UserRole: string = 'User Role';
	static readonly ListType_UserGroup: string = 'User Group';

	//Users List Columns
	static readonly COLUMNS_Users: Column[] = [
		{ order: 1, header: 'Username', field: 'Username', dataTestId: 'userName' },
		{ order: 2, header: 'Display Name', field: 'DisplayName' },
		{ order: 3, header: 'E-mail', field: 'ContactEmail' },
		{ order: 4, header: 'Phone #', field: 'ContactPhone' },
		{ order: 5, header: 'Mobile #', field: 'ContactMobile' },
		{ order: 6, header: 'User Role', field: 'UserRoleName' },
		{ order: 7, header: 'Status', field: 'StatusName', filterdataTestId: 'userStatusFilter' },
	];

	//Export List  User
	static readonly Export_List_Users = [{ NameValue: Constants.ExportReferenceType.Names.UserProfile, CodeValue: Constants.ExportReferenceType.UserProfile }];

	//External Users List Columns
	static readonly COLUMNS_ExternalUsers: Column[] = [
		{ order: 1, header: 'Username', field: 'Username', dataTestId: 'externalUserListUserName' },
		{ order: 2, header: 'Display Name', field: 'DisplayName' },
		{ order: 3, header: 'E-mail', field: 'ContactEmail' },
		{ order: 4, header: 'Phone #', field: 'ContactPhone' },
		{ order: 5, header: 'Mobile #', field: 'ContactMobile' },
		{ order: 6, header: 'User Role', field: 'UserRoleName' },
		{ order: 7, header: 'Status', field: 'StatusName', filterdataTestId: 'externalUserListStatusFilter' },
		{ order: 8, header: 'Type', field: 'UserRelationTypeName', filterdataTestId: 'externalUserListTypeFilter' },
		{ order: 9, header: 'Client', field: 'ClientName', filterdataTestId: 'clientNameFilter' },
		{ order: 10, header: 'Contractor', field: 'BusinessEntityName', filterdataTestId: 'businessEntityNameFilter' },
	];
	static readonly COLUMNS_ClientExternalUsers: Column[] = [
		{ order: 1, header: 'Username', field: 'Username', dataTestId: 'externalUserListUserName' },
		{ order: 2, header: 'Display Name', field: 'DisplayName' },
		{ order: 3, header: 'E-mail', field: 'ContactEmail' },
		{ order: 4, header: 'Phone #', field: 'ContactPhone' },
		{ order: 5, header: 'Mobile #', field: 'ContactMobile' },
		{ order: 6, header: 'User Role', field: 'UserRoleName' },
		{ order: 7, header: 'Status', field: 'StatusName', filterdataTestId: 'externalUserListStatusFilter' },
		{ order: 8, header: 'Type', field: 'UserRelationTypeName', filterdataTestId: 'externalUserListTypeFilter' },
		{ order: 9, header: 'Client', field: 'ClientName', filterdataTestId: 'clientNameFilter' },
	];
	static readonly COLUMNS_ContractorExternalUsers: Column[] = [
		{ order: 1, header: 'Username', field: 'Username', dataTestId: 'externalUserListUserName' },
		{ order: 2, header: 'Display Name', field: 'DisplayName' },
		{ order: 3, header: 'E-mail', field: 'ContactEmail' },
		{ order: 4, header: 'Phone #', field: 'ContactPhone' },
		{ order: 5, header: 'Mobile #', field: 'ContactMobile' },
		{ order: 6, header: 'User Role', field: 'UserRoleName' },
		{ order: 7, header: 'Status', field: 'StatusName', filterdataTestId: 'externalUserListStatusFilter' },
		{ order: 8, header: 'Type', field: 'UserRelationTypeName', filterdataTestId: 'externalUserListTypeFilter' },
		{ order: 9, header: 'Contractor', field: 'BusinessEntityName', filterdataTestId: 'businessEntityNameFilter' },
	];

	//Export List External User
	static readonly Export_List_ExternalUsers = [
		{ NameValue: Constants.ExportReferenceType.Names.ExternalUserProfile, CodeValue: Constants.ExportReferenceType.ExternalUserProfile },
	];

	//User Roles List Columns
	static readonly COLUMNS_UserRoles: Column[] = [
		{ order: 1, header: 'Name', field: 'Name', dataTestId: 'userName', filterdataTestId: 'nameFilter' },
		{ order: 2, header: 'Type', field: 'UserRelationTypeName', dataTestId: 'userRelationTypeName', filterdataTestId: 'userRelationTypeFilter' },
		{ order: 3, header: 'Description', field: 'Description', dataTestId: 'description', filterdataTestId: 'userRelationDescriptionFilter' },
		{
			order: 4,
			header: 'Is System Role?',
			field: 'CopiedFromSystem',
			type: COLUMNTYPES.BOOLEAN,
			isInnerHtmlFormat: true,
			hasFilterHeaderTemplate: true,
			isFilterCallback: true,
			filterType: COLUMNTYPES.BOOLEAN,
		},
	];

	//Export List User Role
	static readonly Export_List_UserRoles = [
		{ NameValue: Constants.ExportReferenceType.Names.UserRole, CodeValue: Constants.ExportReferenceType.UserRole },
		{ NameValue: Constants.ExportReferenceType.Names.UserRolePermission, CodeValue: Constants.ExportReferenceType.UserRolePermission },
	];

	//User Groups List Columns
	static readonly COLUMNS_UserGroups: Column[] = [
		{ order: 1, header: 'Name', field: 'Name', dataTestId: 'userName', filterdataTestId: 'nameFilter' },
		{ order: 2, header: 'Description', field: 'Description', dataTestId: 'description', filterdataTestId: 'userGroupListDescriptionFilter' },
		{ order: 3, header: 'Status', field: 'StatusName', filterdataTestId: 'userGroupListStatusFilter' },
	];

	//Export List User Group
	static readonly Export_List_UserGroups = [{ NameValue: Constants.ExportReferenceType.Names.UserGroup, CodeValue: Constants.ExportReferenceType.UserGroup }];
}
